import * as React from 'react';
import { UIHeading1, UIText2 } from '@cian/ui-kit';

import { Promo } from './Promo';
import * as styles from './styles.css';
import { IRealtyValuationData } from '../../types/realtyValuation';
import { Layout } from '../Layout';

export interface IRealtyValuationProps {
  title: string;
  promoText: IRealtyValuationData['promo'];
  lastUpdatedAt: IRealtyValuationData['lastUpdatedText'];
  content: React.ReactElement<unknown>;
}

export const RealtyValuation: React.FC<IRealtyValuationProps> = props => {
  const { content, title, promoText, lastUpdatedAt } = props;

  return (
    <Layout>
      <div className={styles['title']}>
        <UIHeading1 as="h2">{title}</UIHeading1>
      </div>

      {promoText && (
        <div className={styles['promo']}>
          <Promo {...promoText} />
        </div>
      )}
      {content}
      {lastUpdatedAt && (
        <div className={styles['last-updated']}>
          <UIText2 color="text-secondary-default">{lastUpdatedAt}</UIText2>
        </div>
      )}
    </Layout>
  );
};
